import axios from './request';
import { pipe, defaultTo, prop } from 'ramda';

const suggestions = prop('suggestions');

/**
 * @typedef NameSuggestion
 * @property {string} value
 * @property {object} data
 * @property {string} data.name
 * @property {string} data.surname
 * @property {string} data.patronymic
 * @property {'FEMALE'|'MALE'|'UNKNOWN'} data.gender
 * @property {'1'|'0'} qc
 */

/**
 *
 * @param {string} query
 * @param {import('axios').AxiosRequestConfig?} config
 * @returns {Promise<NameSuggestion[]>}
 */
export function getNameSuggestions(query, config) {
	return axios.get('/api/Dadata/get/', {
		...config,
		params: {
			'type': 'fio',
			query,
		},
	})
		.then(({ data }) => data)
		.then(pipe(
			suggestions,
			defaultTo([]),
		))
}

/**
 * @typedef AddressSuggestion
 * @property {string} value
 * @property {string} unrestricted_value
 */

/**
 *
 * @param {string} query
 * @param {import('axios').AxiosRequestConfig?} config
 * @returns {Promise<AddressSuggestion[]>}
 */
export function getAddressSuggestions(query, config) {
	return axios.get('/api/Dadata/get/', {
		...config,
		params: {
			'type': 'address',
			query,
		},
	})
		.then(({ data }) => data)
		.then(pipe(
			suggestions,
			defaultTo([]),
		))
}
